// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";

// Import utils
import {mapStateToProps} from "../../redux/mapStateToProps";
import {
    GetSubscribers,
    DeleteSubscriberById,
} from "../../redux/actions";

// Import components
import PageWrapper from "../../components/pageContentViews/pageWrapper";
import {deleteItem} from "../../utils/helperFunctions";
import ItemsList from "../../components/ItemsList";
import dayjs from "dayjs";
import ReactExport from "react-data-export";


class Subscribers extends Component {
    constructor(props) {
        super(props);

        this.deleteSubscriberItem = this.deleteSubscriberItem.bind(this);
    }

    componentDidMount() {
        this.props.GetSubscribers();
    }

    deleteSubscriberItem(id){
        this.props.DeleteSubscriberById(id).then(()=>{
            this.props.GetSubscribers();
        })
    }

    render() {
        let {subscribersList, requestLoading} = this.props;
        const ExcelFile = ReactExport.ExcelFile;
        const ExcelSheet = ReactExport.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelColumn;
        let exelData = subscribersList?.map((item) => {return {email:item.email}})


        let itemListHeaderInfo = {
            generalInfo: ["Անվանում", "Ամսաթիվ"],
            largeItems: [],
            actions: ["delete"],
            status: false,
        };
        let itemListInfo = subscribersList?.map((subscriber) => {
            const {id,email, createdAt} = subscriber;
            return {
                id,
                values: [
                    email ?? '-',
                    dayjs(createdAt).format('DD/MM/YYYY HH:mm')
                ],
                deleteCb: deleteItem.bind(this, this.props.DeleteSubscriberById, 'Բաժանորդին', id)
            }
        });
        return <PageWrapper pageTitle={'Բաժանորդներ'}>
           {/* <div className={'exel-file'}>
                <ExcelFile element={<button>Excel</button>} filename={'Emails'} style={{width:300}}>
                    <ExcelSheet data={exelData} name="Emails">
                        <ExcelColumn label="" value="email"/>
                    </ExcelSheet>
                </ExcelFile>
            </div>*/}
            <ItemsList itemListHeaderInfo={itemListHeaderInfo}
                       itemListInfo={itemListInfo}
                       loading={requestLoading} />
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    GetSubscribers,
    DeleteSubscriberById,
};

export default connect(mapStateToProps, mapDispatchToProps)(Subscribers);
